// extracted by mini-css-extract-plugin
export default {"avatarWithDetails":"Hmcyf9dPGtZoIM7i66Tt","title":"XWZYjzbpOAXg8UxCDUtn","details":"daBVgTNLZI7iMjLI3OlS"};